import { render, staticRenderFns } from "./inTransit.vue?vue&type=template&id=2f628f46&scoped=true"
import script from "./inTransit.vue?vue&type=script&lang=js"
export * from "./inTransit.vue?vue&type=script&lang=js"
import style0 from "./inTransit.vue?vue&type=style&index=0&id=2f628f46&prod&scoped=true&lang=scss"
import style1 from "./inTransit.vue?vue&type=style&index=1&id=2f628f46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f628f46",
  null
  
)

export default component.exports